import styles from './AssignmentCard.module.css'

interface AssignmentCardProps {
  name: string
  role?: string
  completed: boolean
  data?: Record<string, unknown>
}

export default function AssignmentCard({ name, role, completed, data }: AssignmentCardProps) {
  const initials = name
    .split(' ')
    .map((w) => w.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase()

  const hasData = data && Object.keys(data).length > 0

  return (
    <div className={styles.card} data-testid={`assignment-card-${name}`}>
      <div className={styles.head}>
        <div className={styles.avatar}>{initials}</div>
        <div>
          <div className={styles.name}>{name}</div>
          {role && <div className={styles.role}>{role}</div>}
          <div className={completed ? styles.statusDone : styles.statusPending}>
            {completed ? '✓ Completed' : 'Not yet completed'}
          </div>
        </div>
      </div>
      {hasData && (
        <div className={styles.data}>
          {Object.entries(data!).map(([k, v]) => {
            if (!v || typeof v !== 'string' || !v.trim()) return null
            return (
              <div className={styles.row} key={k}>
                <span className={styles.key}>{k}</span>
                <span className={styles.val}>{v}</span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
